import ctl from "@netlify/classnames-template-literals";

export const authPageContainer = ctl(`
  flex
  flex-col
  items-center
  justify-center
  mx-auto
  max-w-md
`);
